import React, { useState, useEffect, useContext, useRef } from "react";

import Slider from "react-slick";

import { connect } from "react-redux";
import { toast } from "react-toastify";
import {
  Input,
  Item,
  Message,
  Pagination,
  Divider,
  Icon,
  Button,
  Label,
  Header,
  Grid,
} from "semantic-ui-react";

import BookingsSupplement from "../Bookings/BookingsSupplements/BookingsSupplement";
import ModalTransition from '../ModalTransition/ModalTransition';
import GlobalContext from "../../contexts/GlobalContext";
import { filtredSupplements } from '../../store/supplement'
import { RootDispatch, RootState } from "../../store";
import Loader from "../Basics/Loader";
import ExtraDetails from "../Bookings/BookingsSupplements/ExtraDetails";
import OptionDetails from "../Bookings/BookingsSupplements/OptionDetails";
import Utility from "../../../src/Utility";
import { ResponseManagement } from "../../../src/API";

const mapProps = (state: RootState) => ({
  filtredSupplements: filtredSupplements(state),
  currentSupplementPage: state.supplement.currentPage,
})

const mapDispatch = (dispatch: RootDispatch) => ({
  updateCurrentSupplementPage: dispatch.supplement.updateCurrentPage,
  updateSupplementSearch: dispatch.supplement.updateSearch,
  updateSelectedBooking: dispatch.booking.updateSelectedBooking,
  addSupplementAsync: dispatch.supplement.addSupplementAsync,
});

export type DetailMode = {
  supplement: any;
  quantity: number;
};

type Props = {
  supplements: any
  booking: any
  className?: string
} & ReturnType<typeof mapProps> & ReturnType<typeof mapDispatch>

const OptionExtraCarousel: React.FC<Props> = ({
  filtredSupplements,
  currentSupplementPage,
  updateSupplementSearch,
  updateCurrentSupplementPage,
  updateSelectedBooking,
  addSupplementAsync,
  supplements,
  booking,
  className,
}) => {
  const [globalContext] = useContext(GlobalContext) as any;
  const [, setNav1] = useState(null);
  const [toCloseDetail, setToCloseDetail] = useState<boolean>(false);
  const [isVisibleModal, setIsVisibleModal] = useState<boolean>(false);
  const [detailsMode, setDetailsMode] = useState<DetailMode>({
    supplement: null,
    quantity: null,
  });
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const modalScrollRef = useRef(null)

  let slider1 = null;

  useEffect(() => {
    setNav1(slider1);
  }, []);

  const handleChangePage = (_, el) => {
    modalScrollRef.current.scrollTop = 0
    updateCurrentSupplementPage(el.activePage);
  }

  const searchSupplement = (ev) => {
    updateCurrentSupplementPage(1);
    updateSupplementSearch(ev.currentTarget.value);
  };

  const handleOpenModal = () => {
    setDetailsMode({ supplement: null, quantity: null });
    updateSelectedBooking({ id: booking.id });
    setIsVisibleModal(true);
  };

  const handleCloseModal = () => {
    setIsVisibleModal(false);
    updateSupplementSearch("");
    updateCurrentSupplementPage(1);
  };

  const addSupplement = () => {
    if (!detailsMode.supplement) return;
    setIsLoading(true)
    
    addSupplementAsync({
      bookingId: detailsMode.supplement.bookingId,
      serviceId: detailsMode.supplement.id,
      serviceType: detailsMode.supplement.type,
      quantity: detailsMode.quantity,
    })
      .then((response) => {
        ResponseManagement(
          response,
          () => {
            if (response.data.success) {
              setIsVisibleModal(false)
              toast.success(globalContext.translations.successAddSupplement);
            }
          },
          () => {
            toast.error(
              globalContext.translations.failedAddSupplement +
                ": " +
                response.data.message
            );
          }
        );
      })
      .catch((error) => {
        toast.error(globalContext.translations.failedAddSupplement);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const filtredSupplementsLength = Object.keys(filtredSupplements).length;

  return (
    <div className={className}>
      <div className="mt-3">
        <Header className="text-center" as="h3">
          {globalContext.translations.enhanceYourStay}
        </Header>
        <Divider />
      </div>
      <div className="text-right">
        <Button
          className="mt-2"
          as="div"
          labelPosition="left"
          onClick={handleOpenModal}
        >
          <Label as="a" basic pointing="right">
            {globalContext.translations.allSupplements}
          </Label>
          <Button primary icon>
            <Icon name="window restore outline" />
          </Button>
        </Button>
      </div>
      <ModalTransition
        ref={modalScrollRef}
        open={isVisibleModal}
        handleClose={handleCloseModal}
        closeOnDimmerClick={false}
        size="large"
        header={
          !detailsMode.supplement
            ? globalContext.translations.allSupplements
            : globalContext.translations.confirmAddSupplement
        }
        content={
          <>
            {!detailsMode.supplement && isVisibleModal && (
              <BookingSupplementList
                searchSupplement={searchSupplement}
                translations={globalContext.translations}
                currentSupplementPage={currentSupplementPage}
                toCloseDetail={toCloseDetail}
                booking={booking}
                filtredSupplements={filtredSupplements}
                setDetailsMode={setDetailsMode}
              />
            )}
            {detailsMode.supplement && isVisibleModal && (
              <>
                {detailsMode.supplement.type === "extra" && (
                  <ExtraDetails
                    supplement={detailsMode.supplement}
                    quantity={detailsMode.quantity}
                    currency={booking.currency}
                  />
                )}
                {detailsMode.supplement.type === "option" && (
                  <OptionDetails
                    supplement={detailsMode.supplement}
                    booking={booking}
                  />
                )}
              </>
            )}
            {!isVisibleModal && <Loader active />}
          </>
        }
        actions={
          <>
            {!detailsMode.supplement && filtredSupplementsLength > 1 && (
              <Item.Group divided>
                <Pagination
                  onPageChange={handleChangePage}
                  floated="right"
                  defaultActivePage={currentSupplementPage}
                  totalPages={filtredSupplementsLength}
                  style={{ marginBottom: "15px" }}
                />
              </Item.Group>
            )}
            {detailsMode.supplement && (
              <Button.Group>
                <Button
                  negative
                  onClick={() =>
                    setDetailsMode({ supplement: null, quantity: null })
                  }
                  disabled={isLoading}
                >
                  {Utility.ucFirst(globalContext.translations.back)}
                </Button>
                <Button
                  positive
                  onClick={addSupplement}
                  disabled={isLoading}
                  loading={isLoading}
                >
                  {globalContext.translations.validate}
                </Button>
              </Button.Group>
            )}
          </>
        }
      />
      <Slider
        afterChange={() =>
          toCloseDetail ? setToCloseDetail(false) : setToCloseDetail(true)
        }
        className="first-slider mt-3"
        dots={false}
        ref={(slider) => (slider1 = slider)}
      >
        {supplements.map((supplement, index) => (
          <div key={index}>
            <BookingsSupplement
              booking={booking}
              toCloseDetail={toCloseDetail}
              supplement={supplement}
              setDetailsMode={setDetailsMode}
            />
          </div>
        ))}
      </Slider>
    </div>
  );
};

const BookingSupplementList = ({
  searchSupplement,
  translations,
  currentSupplementPage,
  toCloseDetail,
  booking,
  filtredSupplements,
  setDetailsMode,
}: any) => {
  const filtredSupplementsLength = Object.keys(filtredSupplements).length;

  return (
    <div>
      <Item.Group>
        <div className="mb-5" style={{ textAlign: "center" }}>
          <Input
            spellCheck={false}
            action={{ icon: "search" }}
            onChange={searchSupplement}
            placeholder={`${translations.search}...`}
          />
        </div>
      </Item.Group>
      <Item.Group>
        <Grid style={{width: '100%', margin: 'auto'}} columns="equal">
          {filtredSupplements?.[currentSupplementPage]?.map(
            (supplement, index) => {
              const lastItem =
                filtredSupplements[currentSupplementPage].length - 1 === index;

              return (
                <Grid.Column key={supplement.id} computer={8} mobile={16}>
                  <BookingsSupplement
                    toCloseDetail={toCloseDetail}
                    lastItem={lastItem}
                    fromModal
                    booking={booking}
                    supplement={supplement}
                    setDetailsMode={setDetailsMode}
                  />
                </Grid.Column>
              );
            }
          )}
        </Grid>
      </Item.Group>
      {filtredSupplementsLength === 0 && (
        <Message style={{ textAlign: "center" }} negative>
          <p>{translations.noOptionsForYourSearch}</p>
        </Message>
      )}
    </div>
  );
};

export default connect(mapProps, mapDispatch)(OptionExtraCarousel);
